import { useMutation } from "@apollo/client";
import { LoginWithPhoneMutation, LoginWithPhoneMutationVariables } from "@ctypes";
import { LOGIN_WITH_PHONE } from "@graphql";

export const useLoginWithPhone = () => {
  return useMutation<LoginWithPhoneMutation, LoginWithPhoneMutationVariables>(LOGIN_WITH_PHONE);
};
